function UI(options) {
    this.defaults = {
    };
    $.extend(this, this.defaults, options);
    this.init();
}

UI.prototype.init = function() {
    var self = this;
    this.handleDropdown();
    this.handleFilter();
    this.handleButtons();
    this.handleMessages();
    this.handleCustomSelectEvents();
};

UI.prototype.handleDropdown = function() {
	var self = this;
    $('.dropdown-header').on('click', function(e) {
        e.stopPropagation();
        $(this).closest('.dropdown').toggleClass('-active');
    });
    $('.dropdown-item').on('click', function(e) {
        var html = $(this).html();
        $(this).addClass('-selected').siblings().removeClass('-selected');
        $(this).closest('.dropdown').addClass('-selected').find('.dropdown-header > div').html(html);
    });
    document.addEventListener("click", function() {
        $('.dropdown').removeClass('-active');
    });
};

UI.prototype.handleFilter = function(){
    //console.log('publikacje');
    var url = $('.square-index-filter').attr('data-url');
    var click = false;
    $('.square-index-filter label').click( function(e) {
        //e.preventDefault();
        //console.log(url);
        if (!click) {
            var id = $(this).attr('data-id');
            window.location = url + '?cat=' + id;
            click = true;
        }
    });
};

UI.prototype.handleButtons = function() {
    var self = this;
};

UI.prototype.handleMessages = function() {
    const closedMessages = JSON.parse(localStorage.getItem('closedMessages')) || [];
    closedMessages.forEach(element => {
        $('.messages-index-item[data-id="' + element + '"]').remove();
    });
    $('.messages-index-item').addClass('-visible');
    if ($('.section--messages').children().length === 0) {
        $('.section--messages').remove();
    }

    $('.messages-index-item__close').on('click', function(e) {
        e.preventDefault();
        var closedMessages = JSON.parse(localStorage.getItem('closedMessages')) || [];
        closedMessages.push($(this).closest('.messages-index-item').attr('data-id'));
        localStorage.setItem('closedMessages', JSON.stringify(closedMessages));
        $(this).closest('.messages-index-item').remove();
        if ($('.section--messages').children().length === 0) {
            $('.section--messages').remove();
        }
    });
};

UI.prototype.handleCustomSelectEvents = function() {
	var self = this;
};